import { AnaColumn } from "../forms-template.service";
import { aspect } from "./aspect";


export const imballo2AleAnaColumn: AnaColumn[] = [
  {
    configuration:
    {
      titleGriglia: 'Imballi ',
      titleForm: 'Gestione imballi ',
      breadcrumbCaption: 'Gestione imballi',
      service: 'imballo',
      api: 'imballo',
      filterList: '',
      filterEditor: '/$',
      formType: 'simple',
      masterKey: 'id',
      nCol: 1,     

    }

  },


  {
    itemType: "group", colCount: "1", caption: "Specifiche imballo",
    data:
      [
        {
          type: 'campo', caption: ' ', 
          colVisible: false, 
          hideOnEdit: true, 
          showEditorAlways: false, 
          disableOnUpdate: true, 
          dataField: "id", 
          colWidth: '20px'
        },

        {
          type: 'campo', class: "",  dataField: "descrizione", dataType: "", 
          caption: "Descrizione",
          maxLength:'60',
          width:'',
          colWidth:'450',
          validation: [{ type: "required", message: "Campo Obbligatorio" },],
        },       
        {
          type: 'campo',  dataField: "tipoImballo", 
          dataType: "", caption: "Tipo Imballo",
          editorType:'dxSelectBox',
          width:'',
          colWidth:'120',
          lista: {
            static: false,
            dataSource: 'tipoImballo', 
            valueExpr: 'id', 
            displayExpr: 'descrizione',
            
          },
          validation: [{ type: "required", message: "Campo Obbligatorio" },],
        }
      ]
  }]

export const imballo: AnaColumn[] = [
  {
    configuration:
    {
      titleGriglia: 'Imballi ',
      titleForm: 'Gestione imballi ',
      breadcrumbCaption: 'Gestione imballi',
      service: 'imballo',
      api: 'imballo',
      filterList: '',
      filterEditor: '/$',
      formType: 'simple',
      masterKey: 'id',
      nCol: 1,     

    }

  },


  {
    itemType: "group", colCount: "1", caption: "Specifiche imballo",
    data:
      [
        {
          type: 'campo', caption: ' ', 
          colVisible: false, 
          hideOnEdit: true, 
          showEditorAlways: false, 
          disableOnUpdate: true, 
          dataField: "id", 
          colWidth: '20px'
        },

        {
          type: 'campo', class: "",  dataField: "descrizione", dataType: "", 
          caption: "Descrizione",
          maxLength:'60',
          width:'21vw',
          colWidth:'450',
          validation: [{ type: "required", message: "Campo Obbligatorio" },],
        },       
        {
          type: 'campo',  dataField: "tipoImballo", 
          dataType: "", caption: "Tipo Imballo",
          editorType:'dxSelectBox',
          width:'21vw',
          colWidth:'120',
          lookup: {
            static: false,
            wingap:true,
            dataSource: 'tipoImballo', 
            valueExpr: 'id', 
            displayExpr: 'descrizione',
            colonne:[
              {caption:'Tipo Imballo',dataField:'descrizione'}
            ]

          },
          validation: [{ type: "required", message: "Campo Obbligatorio" },],
        }
      ]
  }]